var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegramDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.088 5.38648C27.6594 5.02305 26.9863 4.97105 26.2903 5.25048H26.2891C25.5571 5.5442 5.5685 14.1179 4.75478 14.4682C4.60678 14.5197 3.31421 15.0019 3.44735 16.0762C3.56621 17.0448 4.60507 17.4459 4.73192 17.4922L9.81365 19.2322C10.1508 20.3545 11.3937 24.4951 11.6685 25.3797C11.8399 25.9311 12.1194 26.6557 12.6091 26.8048C13.0388 26.9705 13.4662 26.8191 13.7428 26.602L16.8497 23.7203L21.8651 27.6317L21.9846 27.7031C22.3251 27.854 22.6514 27.9294 22.9628 27.9294C23.2034 27.9294 23.4343 27.8843 23.6548 27.794C24.4063 27.4854 24.7068 26.7694 24.7383 26.6883L28.4846 7.21563C28.7131 6.17563 28.3954 5.64649 28.088 5.38648ZM14.2954 19.9282L12.5811 24.4997L10.8668 18.7854L24.0097 9.07107L14.2954 19.9282Z",
    fill: "#56565A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramDesktop);
export default __webpack_public_path__ + "static/media/Telegram-desktop.89a65ab8f15138266ff21c74e3f8b169.svg";
export { ForwardRef as ReactComponent };